<template>
  <div>
    <CustomCollaspe
      class="filter-collapse status"
      :collapse-id="'status-collapse-1'"
      :collapse-header="'Sell Method'"
    >
      <FilterOptionBtn
        :selected="data.sellMethod === sellMethodText.fixedPrice"
        @onClick="() => updateData(sellMethodText.fixedPrice)"
      >
        Fixed Price
      </FilterOptionBtn>
      <FilterOptionBtn
        :selected="data.sellMethod === sellMethodText.dutchAuction"
        @onClick="() => updateData(sellMethodText.dutchAuction)"
      >
        Ducth Auction
      </FilterOptionBtn>
      <FilterOptionBtn
        :isDisable="true"
        :selected="data.sellMethod === sellMethodText.auction"
        @onClick="() => updateData(sellMethodText.auction)"
      >
        Auction
      </FilterOptionBtn>
    </CustomCollaspe>
  </div>
</template>

<script>
import CustomCollaspe from '@/components/BaseComponents/CustomCollapse.vue';
import FilterOptionBtn from '@/components/BaseComponents/FilterOptionBtn.vue';
import { SELLING_METHOD_TEXT } from '@/constans';

export default {
  components: {
    CustomCollaspe,
    FilterOptionBtn
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      sellMethodText: SELLING_METHOD_TEXT
    };
  },
  methods: {
    updateData(sellMethod) {
      this.$emit('update:data', { ...this.data, sellMethod });
    }
  }
};
</script>
